import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setAsDefaultView: {
		id: 'navigation-kit-tab-menu.set-as-default-item.set-as-default-view',
		defaultMessage: 'Set as default',
		description: 'Set as default view option in the project navigation context menu.',
	},
	selected: {
		id: 'navigation-kit-tab-menu.set-as-default-item.selected',
		defaultMessage: 'Selected',
		description:
			'Label for icon that represents the selected state of the set as default view option in the project navigation context menu.',
	},
});
